
// @ts-check

import { performQuerySpecApiRequestPromise } from './PerformQuerySpecApiRequest';
import { mergeCardsIntoOne } from './DonorCardMerger';

/**
 * @typedef {import('./coreTypes').ResultAtom} ResultAtom
 * @typedef {import('./coreTypes').ResultAtomPartial} ResultAtomPartial
 * @typedef {import('./coreTypes').PartialDonorData} PartialDonorData
 * @typedef {import('./coreTypes').DonorData} DonorData
 * @typedef {import('./coreTypes').QuerySpec} QuerySpec
 */


/**
 * @param {ResultAtomPartial[]} donors
 * @return {Promise<ResultAtom[]>} 
 */
function resolvePartialResultAtoms(donors) {
    return Promise.all(donors.map(resolvePartialAtom)).then(r => r.flatMap(r => (r === null) ? [] : [r]));
}

/**
 * 
 * @param {ResultAtomPartial} donor
 * @return {Promise<ResultAtom|null>} 
 */
function resolvePartialAtom(donor) {
    switch (donor[0]) {
        case 'donor':
        case 'donor_legacy': return new Promise(r => r(donor));
        case 'partial_donor': return fillInPartial(donor);
        default: throw new Error("unknown donor type");
    }
}

/**
 * @param {['partial_donor', PartialDonorData]} partialDonor
 * @return {Promise<['donor', DonorData] | null>} 
 */
function fillInPartial(partialDonor) {

    const dd = partialDonor[1];
    /**
     * @type {QuerySpec}
     */
    const querySpec = [['donor_name', dd['name']]];
    const wantedPidm = dd['pidm'];

    let chunkSize = 10000;
    let currentOffset = 0;

    /** @type {['donor', DonorData][]} */
    let results = [];

    /** @type {function(ResultAtomPartial[]): Promise<['donor', DonorData] | null>} */
    let handler;

    /**
     * @param {ResultAtomPartial[]} response
     * @return {Promise<['donor', DonorData] | null>}
     */ 
    handler = response => {
        if (response.length === 0) {
            return new Promise(resolve => resolve(mergeCardsIntoOne(results)));
        }
        else {
            response.forEach(r => {
                if (r[0] === 'donor') {
                    if (r[1]['id'] === wantedPidm) {
                        results.push(r);
                    }
                }
            });
            currentOffset += chunkSize;
            return performQuerySpecApiRequestPromise(querySpec, currentOffset, chunkSize).then(handler);
        }
    };

    return performQuerySpecApiRequestPromise(querySpec, currentOffset, chunkSize).then(handler);
}


export { resolvePartialResultAtoms };